import React, { ReactElement } from 'react'
import { StyleProp, StyleSheet, TextStyle, View, ViewProps } from 'react-native'

import { Color, Spacing } from '../../style'
import { Help } from '../help'
import { Text } from '../typography'

const styles = StyleSheet.create({
  container: {
    zIndex: 100,
  },
  top: {
    flexDirection: 'row',
  },
  topLeft: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
  },
  label: {
    marginBottom: Spacing.XXS,
  },
  labelDisabled: {
    color: Color.calmGrey,
  },
  labelError: {
    color: Color.soothingPink,
  },
  error: {
    zIndex: -1,
    fontSize: 14,
    marginTop: Spacing.XXS,
    color: Color.soothingPink,
  },
  skeletonLabel: {
    width: 200,
  },
})

export interface Props extends ViewProps {
  label?: string | ReactElement
  labelStyle?: StyleProp<TextStyle>
  error?: string
  disabled?: boolean
  header?: ReactElement
  help?: string | ReactElement
}
const FormField = (props: Props) => {
  const { label, error, disabled, header, help, children, style, labelStyle, ...otherProps } = props

  const content = (label || header) && (
    <View style={styles.top}>
      <View style={styles.topLeft}>
        {label &&
          (typeof label === 'string' ? (
            <Text
              style={[styles.label, !!error && styles.labelError, disabled && styles.labelDisabled, labelStyle]}
              level={5}
            >
              {label}
            </Text>
          ) : (
            <View style={styles.label}>{label}</View>
          ))}
      </View>
      {header}
    </View>
  )

  return (
    <View style={[styles.container, style]} {...otherProps}>
      {help ? <Help message={help}>{content}</Help> : content}
      {children}
      {error && (
        <Text style={styles.error} testID="FormField.Error">
          {error}
        </Text>
      )}
    </View>
  )
}

interface SkeletonProps extends ViewProps {
  label?: string | ReactElement | true
  header?: ReactElement
  labelStyle?: StyleProp<TextStyle>
}
FormField.Skeleton = (props: SkeletonProps) => {
  const { label, header, labelStyle, style, children, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.top}>
        <View style={styles.topLeft}>
          {label === true ? (
            <Text.Skeleton level={5} style={[styles.label, styles.skeletonLabel, labelStyle]} />
          ) : typeof label === 'string' ? (
            <Text level={5} style={[styles.label, labelStyle]}>
              {label}
            </Text>
          ) : (
            label
          )}
        </View>
        {header}
      </View>
      {children}
    </View>
  )
}

export default FormField
